import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'tierV2Color',
})
export class TierV2ColorPipe implements PipeTransform {
  public transform(value: any): string {
    switch (value) {
      case 'black':
        return '#000000';
      case 'gold':
        return '#FFD600';
      case 'silver':
        return '#92A0AD';
      case 'blue':
        return '#448AFF';
      default:
        return '#448AFF';
    }
  }
}
